exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search .element-box {\n  padding: 1rem 1rem !important;\n  margin-bottom: .1rem; }\n\n.search .range-slider-input {\n  display: inline-block;\n  width: 90px;\n  text-align: right;\n  margin: -4px 0 0 6px; }\n  .search .range-slider-input > input {\n    padding-right: 2px; }\n  .search .range-slider-input-start {\n    margin-right: 6px; }\n\n.search .SelectCollapsible:last-child {\n  border-bottom: unset !important; }\n\n.search .range-label-start-end {\n  font-size: 14px; }\n\n#Loader {\n  width: inherit !important;\n  left: 0;\n  right: 0;\n  margin: 0 14px;\n  padding-top: 20rem !important; }\n", ""]);

// exports
